const SELECTED_BRANCH_STORAGE_KEY = 'TREE_PANEL_SELECTED_BRANCH_ID'
export const SELECTED_SYSTEM_STORAGE_KEY = 'TREE_PANEL_SELECTED_SYSTEM_ID'
export const SELECTION_CHANGED_EVENT = 'mdd-selection-changed'

type BranchBySystem = Record<string, string>

export const readStoredBranchBySystem = (): BranchBySystem => {
	try {
		const raw = localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY)
		if (!raw) return {}
		const parsed = JSON.parse(raw) as unknown
		if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
			return parsed as BranchBySystem
		}
		return {}
	} catch {
		return {}
	}
}

export const writeStoredBranchBySystem = (branchBySystem: BranchBySystem) => {
	try {
		localStorage.setItem(
			SELECTED_BRANCH_STORAGE_KEY,
			JSON.stringify(branchBySystem),
		)
	} catch {
		// ignore storage errors
	}
}

export const readSelectedBranchNumericId = (): number | undefined => {
	try {
		const systemId = localStorage.getItem(SELECTED_SYSTEM_STORAGE_KEY)
		if (!systemId) return undefined
		const stored = readStoredBranchBySystem()[systemId]
		if (!stored) return undefined
		const branchId = Number(stored)
		return Number.isNaN(branchId) ? undefined : branchId
	} catch {
		return undefined
	}
}

export const rememberSystemBranch = (systemId: number, branchId: number) => {
	localStorage.setItem(SELECTED_SYSTEM_STORAGE_KEY, String(systemId))
	const branchBySystem = readStoredBranchBySystem()
	branchBySystem[String(systemId)] = String(branchId)
	writeStoredBranchBySystem(branchBySystem)
	window.dispatchEvent(new Event(SELECTION_CHANGED_EVENT))
}

export const requireSelectedBranchId = (): number => {
	const branchId = readSelectedBranchNumericId()
	if (branchId == null) {
		throw new Error('No branch selected')
	}
	return branchId
}
